import { AvailableUnit, AvailableUnitExtended } from "../types/property-types";

export const deleteUndefined = <T>(input: T): T => {
  const obj = input as Record<string, any> | undefined;
  if (obj) {
    Object.keys(obj).forEach((key: string) => {
      if (typeof obj[key] === "undefined") {
        delete obj[key]; // eslint-disable-line no-param-reassign
      }
    });
  }
  return input;
};

export const reduceAvailableUnits = ({
  units,
  removeRentMatrix,
  removePrices,
}: {
  units?: AvailableUnit[];
  removeRentMatrix?: boolean;
  removePrices?: boolean;
}): AvailableUnit[] => {
  if (!units) {
    return [];
  }
  const reducedUnits = JSON.parse(JSON.stringify(units)) as AvailableUnit[];
  reducedUnits.forEach((unit) => {
    if (removeRentMatrix) {
      unit.rentMatrix = {};
    }
    if (removePrices) {
      (unit as AvailableUnitExtended).prices = [];
    }
  });
  return reducedUnits;
};
